export default {
  both: [
    {
      path: "/auth/impersonate",
      name: "auth.impersonate",
      component: () => import("./views/ImpersonateView.vue")
    }
  ]
};
